// components/Draggable/sortable.scss
.opacity-0 {
  opacity: 0 !important;
}

.movable {
  cursor: move;
}

.bb:has([data-dragging]) {
  border-bottom-color: transparent;
}
